export default "__VITE_ASSET__b8e4e6bb__"